import { get } from 'lodash/fp';
import { createSelector } from 'reselect';

export const getROItemCreate = get('reservation.routes.ROItem.create');

export const getIsSaving = createSelector(getROItemCreate, get('saving'));

export const getIsSaved = createSelector(getROItemCreate, get('saved'));
